import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "16", "height": "16", "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M11 8.00004C11 9.65689 9.65685 11 8 11C6.34315 11 5 9.65689 5 8.00004C5 6.34319 6.34315 5.00004 8 5.00004C9.65685 5.00004 11 6.34319 11 8.00004ZM9.66667 8.00004C9.66667 8.92052 8.92048 9.66671 8 9.66671C7.07953 9.66671 6.33333 8.92052 6.33333 8.00004C6.33333 7.07957 7.07953 6.33337 8 6.33337C8.92048 6.33337 9.66667 7.07957 9.66667 8.00004Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M8 13.6667C12 13.6667 15.1111 9.74363 16 8.00004C15.1111 6.25645 12 2.33337 8 2.33337C4 2.33337 0.888889 6.25645 0 8.00004C0.888889 9.74363 4 13.6667 8 13.6667ZM3.7045 10.4778C2.7503 9.65429 2.00541 8.71827 1.54146 8.00004C2.00541 7.28181 2.7503 6.34579 3.7045 5.52224C4.96293 4.43612 6.44163 3.66671 8 3.66671C9.55838 3.66671 11.0371 4.43612 12.2955 5.52224C13.2497 6.34579 13.9946 7.28181 14.4585 8.00004C13.9946 8.71827 13.2497 9.65429 12.2955 10.4778C11.0371 11.564 9.55838 12.3334 8 12.3334C6.44163 12.3334 4.96293 11.564 3.7045 10.4778Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const ShowContentIcon = __component__.exports;
export {
  ShowContentIcon as default
};
